export default {
  namespaced: true,
  state: () => ({
    item: null,
    type: '',
  }),
  mutations: {
    set(state, payload) {
      state.item = payload?.item ?? null;
      state.type = payload?.type ?? null;
    },
  },
};
